/*
 * Copyright Huesik (c) 2019.
 */

import axiosInstance from '../core/modules/axiosInstance'

const maps = {
  async searchByNearPlace (options) {
    const query = options.query
    const coordinate = options.coordinate
    const center = options.center

    return await axiosInstance.get(`/maps/searchByNearPlace?center=${center}&query=${query}&coordinate=${coordinate}`)
  }
}

export default maps
